<header
  class="bg-white tw-shadow fx-center px-3 py-2"
  customerScreenType>
  <nav class="w-full mx-auto">
    <div class="fx-row fx-justify-between fx-align-center">
      <div
        id="hamburger-menu"
        class="bg-grey-100 mr-3 my-n-2 w-16 ml-n-1 fx-center h-13">
        <button
          mat-icon-button
          color="accent"
          class="fx-row fx-center text-grey-400 h-13"
          (click)="toggleSidebar && toggleSidebar()">
          <mat-icon class="min-s-8">apps</mat-icon>
        </button>
      </div>

      <a
        class="d-inline-flex mr-auto pr-3"
        routerLink="/">
        <img
          src="assets/images/svg/azzurro.svg"
          alt="Logo"
          id="logo">
        <img
          src="assets/images/svg/azzurro-reduced.svg"
          alt="Logo"
          class="my-n-2"
          id="logo-reduced">
      </a>

      <div class="fx-row fx-center fx-gap-2">
        <customer-header-options
          class="fx-row"
          [interactive]="false">
          <customer-header-options-item
            id="search-system-icon"
            (click)="openMobileSearch()">
            <mat-icon>manage_search</mat-icon>
          </customer-header-options-item>
        </customer-header-options>
        <customer-search-system
          id="search-system"
          [systems]="systems"
          [query]="search">
        </customer-search-system>
        <customer-header-options
          class="fx-row"
          [interactive]="false">
          <customer-header-options-item
            *ngIf="options.showNewPlant"
            class="text-capitalize"
            [accent]="true"
            [routerLink]="['/', 'customer', 'create']">
            <mat-icon fontIcon="add_circle"></mat-icon>
            <span id="new-plant">{{ 'i18n.Common.newPlant' | translate }}</span>
          </customer-header-options-item>
          <customer-header-options-item
            *ngIf="options.showMyPlants"
            tooltip
            id="large-my-plants"
            class="text-capitalize"
            tooltipMode="click"
            [tooltipTemplate]="myPlantsTemplate"
            [tooltipPosition]="tooltipsTemplatePosition">
            <mat-icon fontIcon="list"></mat-icon>
            <span>{{ 'i18n.Common.myPlants' | translate }}</span>
          </customer-header-options-item>
          <customer-header-options-item
            id="small-my-plants"
            (click)="openMobileChoosePlant()">
            <mat-icon fontIcon="swap_vert"></mat-icon>
          </customer-header-options-item>
          <customer-header-options-item
            *ngIf="is_developer$ | async"
            id="appsync-env"
            tooltip
            tooltipMode="click"
            [tooltipTemplate]="appsyncEnvTemplate"
            [tooltipPosition]="tooltipsTemplatePosition">
            <mat-icon>dns</mat-icon>
            <span id="appsync-env-label">{{ (envGateway$ | async) ?? 'Env' }}</span>
          </customer-header-options-item>
          <customer-header-options-item
            *ngIf="refreshService.selectedRefreshTime$ | async as refreshTime"
            id="refresh-timer"
            tooltip
            tooltipMode="click"
            [tooltipTemplate]="selectRefreshTimeTemplate"
            [tooltipPosition]="tooltipsTemplatePosition">
            <mat-icon svgIcon="customer_time_refresh"></mat-icon>
            <span id="refresh-timer-label">{{ refreshTime.label }}</span>
          </customer-header-options-item>
          <customer-header-options-item
            id="refresh-now"
            (click)="refreshService.refresh$.next()">
            <mat-icon svgIcon="customer_refresh"></mat-icon>
          </customer-header-options-item>
          <customer-header-options-item
            *ngIf="currentLang$ | async as lang"
            id="language"
            tooltip
            class="text-capitalize"
            tooltipMode="click"
            data-testid="header-language-dropdown"
            [tooltipTemplate]="languageTemplate"
            [tooltipPosition]="tooltipsTemplatePosition">
            <mat-icon
              *ngIf="lang.src"
              slot="icon-only"
              [svgIcon]="lang.id">
            </mat-icon>
            <span id="language-label">{{ lang.id }}</span>
          </customer-header-options-item>
          <customer-header-options-item
            class="max-w-30"
            id="avatar"
            data-testid="header-avatar"
            tooltip
            (click)="toggleSidebarRight && toggleSidebarRight()">
            <mat-icon
              class="rounded text-white"
              svgIcon="customer_avatar">
            </mat-icon>
            <span
              id="user-name"
              class="ellipsed">
              {{ user?.email | apply : ShortName : user?.displayName }}
            </span>
          </customer-header-options-item>
        </customer-header-options>
      </div>
    </div>
  </nav>
</header>

<ng-template #myPlantsTemplate>
  <customer-plant-card-list
    class="w-75"
    [refresh$]="refreshService.refresh$"
    [systems]="systems">
  </customer-plant-card-list>
</ng-template>

<ng-template #languageTemplate>
  <customer-language-selector></customer-language-selector>
</ng-template>

<ng-template #selectRefreshTimeTemplate>
  <customer-refresh-selector></customer-refresh-selector>
</ng-template>

<ng-template #appsyncEnvTemplate>
  <customer-appsync-env-selector></customer-appsync-env-selector>
</ng-template>

<ng-template
  #mobileSystemCardList
  let-data>
  <mat-dialog-content class="p-3">
    <customer-plant-card-list
      class="w-75"
      [systems]="data">
    </customer-plant-card-list>
  </mat-dialog-content>
</ng-template>

<ng-template
  #mobileSearchSystem
  let-data>
  <mat-dialog-content class="p-3">
    <customer-search-system
      [dialogMode]="true"
      [systems]="data.systems"
      [query]="data.query">
    </customer-search-system>
  </mat-dialog-content>
</ng-template>
